export default __webpack_public_path__ + "334c57741a5a5b21ee05f87da8ed14c6.png";